import styled from 'styled-components';

export const StatementOCRUploadTabLayout = styled.div`
  bottom: 0;
  left: 0;
  overflow: auto;
  padding: 32px;
  position: absolute;
  right: 0;
  top: 0;
`;
